(function () {
  var instances = new WeakMap();

  function parseSources(value) {
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && item.url;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = !!hidden;
  }

  function ProductVideos(root) {
    this.root = root;
    this.player = root.querySelector('[data-pv-player]');
    this.iframe = root.querySelector('[data-pv-iframe]');
    this.frame = root.querySelector('[data-pv-frame]');
    this.stage = root.querySelector('[data-pv-stage]');
    this.failedVideos = new WeakSet();
    this.failedSources = new WeakSet();
    this.title = root.querySelector('[data-pv-title]');
    this.caption = root.querySelector('[data-pv-caption]');
    this.creator = root.querySelector('[data-pv-creator]');
    this.bylineMeta = root.querySelector('[data-pv-byline-meta]');
    this.avatar = root.querySelector('[data-pv-avatar]');
    this.avatarImage = root.querySelector('[data-pv-avatar-image]');
    this.avatarInitials = root.querySelector('[data-pv-avatar-initials]');
    this.centerPlay = root.querySelector('[data-pv-center-play]');
    this.shareBtn = root.querySelector('[data-pv-share]');
    this.reportBtn = root.querySelector('[data-pv-report]');
    this.toast = root.querySelector('[data-pv-toast]');
    this.buttons = root.querySelectorAll('[data-pv-item]');
    this.placeholder = root.getAttribute('data-placeholder') === 'true';
    this.reportEmail = root.getAttribute('data-report-email') || 'service@spotmatecare.com';
    this.toastTimer = null;
    this.onClick = this.onClick.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onError = this.onError.bind(this);
    this.onLoaded = this.onLoaded.bind(this);
    this.bind();
    this.syncInitialMedia();
  }

  ProductVideos.prototype.bind = function () {
    this.root.addEventListener('click', this.onClick);
    if (!this.player) return;
    this.player.addEventListener('play', this.onPlay);
    this.player.addEventListener('pause', this.onPause);
    this.player.addEventListener('ended', this.onPause);
    this.player.addEventListener('error', this.onError);
    this.player.addEventListener('loadeddata', this.onLoaded);
    this.bindSourceErrors();
  };

  ProductVideos.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    if (this.toastTimer) window.clearTimeout(this.toastTimer);
    this.stopIframe();
    if (!this.player) return;
    this.player.removeEventListener('play', this.onPlay);
    this.player.removeEventListener('pause', this.onPause);
    this.player.removeEventListener('ended', this.onPause);
    this.player.removeEventListener('error', this.onError);
    this.player.removeEventListener('loadeddata', this.onLoaded);
    this.player.pause();
  };

  ProductVideos.prototype.onClick = function (event) {
    if (event.target.closest('[data-pv-center-play]')) {
      event.preventDefault();
      this.play();
      return;
    }
    if (event.target.closest('[data-pv-share]')) {
      event.preventDefault();
      this.share();
      return;
    }
    if (event.target.closest('[data-pv-report]')) {
      event.preventDefault();
      this.report();
      return;
    }
    var button = event.target.closest('[data-pv-item]');
    if (!button || !this.root.contains(button)) return;
    this.select(button);
  };

  ProductVideos.prototype.play = function () {
    var current = Array.from(this.buttons).find(function (button) {
      return button.getAttribute('aria-current') === 'true';
    });
    if (current && current.getAttribute('data-video-type') === 'youtube') {
      this.showIframe(current);
      this.setPlaying(true);
      return;
    }
    if (this.placeholder || !this.player) return;
    var playPromise = this.player.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  };

  ProductVideos.prototype.setPlaying = function (playing) {
    if (this.frame) this.frame.classList.toggle('is-playing', !!playing);
    if (this.centerPlay) this.centerPlay.hidden = !!playing;
  };

  ProductVideos.prototype.stopIframe = function () {
    if (!this.iframe) return;
    this.iframe.hidden = true;
    this.iframe.setAttribute('aria-hidden', 'true');
    this.iframe.removeAttribute('src');
  };

  ProductVideos.prototype.showIframe = function (button, autoplay) {
    if (!this.iframe) return;
    var embedUrl = button.getAttribute('data-embed-url') || '';
    if (!embedUrl) return;
    if (autoplay === false) {
      embedUrl = embedUrl.replace(/([?&])autoplay=1\b/, '$1autoplay=0');
    }
    if (this.player) {
      this.player.pause();
      this.player.hidden = true;
      this.player.setAttribute('aria-hidden', 'true');
    }
    this.iframe.hidden = false;
    this.iframe.removeAttribute('aria-hidden');
    this.iframe.title = button.getAttribute('data-title') || '';
    this.iframe.src = embedUrl;
  };

  ProductVideos.prototype.syncInitialMedia = function () {
    var current = Array.from(this.buttons).find(function (button) {
      return button.getAttribute('aria-current') === 'true';
    });
    if (!current || current.getAttribute('data-video-type') !== 'youtube') {
      if (this.player) {
        this.player.hidden = false;
        this.player.removeAttribute('aria-hidden');
      }
      this.stopIframe();
      return;
    }
    this.showIframe(current, false);
    this.setPlaying(false);
  };

  ProductVideos.prototype.onPlay = function () {
    this.setPlaying(true);
    document.querySelectorAll('[data-product-videos] [data-pv-player]').forEach(function (video) {
      if (video !== this.player && !video.paused) video.pause();
    }, this);
  };

  ProductVideos.prototype.onPause = function () {
    this.setPlaying(false);
  };

  ProductVideos.prototype.onError = function (event) {
    var current = Array.from(this.buttons).find(function (button) {
      return button.getAttribute('aria-current') === 'true';
    });
    // Native media errors only apply while the native player is active.
    if (!this.player || this.player.hidden ||
        (current && current.getAttribute('data-video-type') === 'youtube')) return;
    // Let the browser try every encoding before skipping a playlist item.
    if (event && event.target !== this.player) {
      if (!this.player.contains(event.target)) return;
      this.failedSources.add(event.target);
      var sources = Array.from(this.player.querySelectorAll('source'));
      if (sources.some(function (source) { return !this.failedSources.has(source); }, this)) return;
    }
    this.setPlaying(false);
    if (current) {
      this.failedVideos.add(current);
      var row = current.closest('li') || current;
      row.hidden = true;
      row.style.display = 'none';
    }
    var next = Array.from(this.buttons).find(function (button) {
      return !this.failedVideos.has(button);
    }, this);
    if (next) {
      this.select(next);
    } else {
      this.player.pause();
      var section = this.root.closest('.shopify-section') || this.root;
      section.hidden = true;
      section.style.display = 'none';
    }
  };

  ProductVideos.prototype.onLoaded = function () {
    this.failedSources = new WeakSet();
  };

  ProductVideos.prototype.currentTitle = function () {
    return (this.title && this.title.textContent) || document.title;
  };

  ProductVideos.prototype.shareUrl = function () {
    var url = new URL(window.location.href);
    url.hash = this.root.id || 'Videos';
    return url.toString();
  };

  ProductVideos.prototype.share = function () {
    var title = this.currentTitle();
    var url = this.shareUrl();
    var payload = { title: title, text: title, url: url };
    if (navigator.share) {
      navigator.share(payload).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(this.showToast.bind(this)).catch(this.showToast.bind(this));
      return;
    }
    this.showToast();
  };

  ProductVideos.prototype.report = function () {
    var title = this.currentTitle();
    var subject = 'Report product video: ' + title;
    var body = 'I would like to report this product video on ' + this.shareUrl();
    window.location.href = 'mailto:' + this.reportEmail +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);
  };

  ProductVideos.prototype.showToast = function () {
    if (!this.toast) return;
    this.toast.hidden = false;
    this.toast.classList.add('is-visible');
    if (this.toastTimer) window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(function () {
      this.toast.classList.remove('is-visible');
      this.toast.hidden = true;
    }.bind(this), 1800);
  };

  ProductVideos.prototype.updateOverlay = function (button) {
    var title = button.getAttribute('data-title') || '';
    var creator = button.getAttribute('data-creator') || '';
    var avatar = button.getAttribute('data-avatar') || '';
    var initials = button.getAttribute('data-initials') || (creator ? creator.charAt(0) : '');

    if (this.title) this.title.textContent = title;
    if (this.creator) {
      this.creator.textContent = creator;
      setHidden(this.creator, creator === '');
    }
    if (this.bylineMeta) setHidden(this.bylineMeta, creator === '');

    if (this.avatarImage) {
      if (avatar) {
        this.avatarImage.src = avatar;
        this.avatarImage.hidden = false;
      } else {
        this.avatarImage.removeAttribute('src');
        this.avatarImage.hidden = true;
      }
    }
    if (this.avatarInitials) {
      this.avatarInitials.textContent = initials.toUpperCase();
      setHidden(this.avatarInitials, avatar !== '' || initials === '');
    }
    if (this.avatar) setHidden(this.avatar, avatar === '' && initials === '');
  };

  ProductVideos.prototype.select = function (button) {
    if (this.failedVideos.has(button)) return;
    if (button.getAttribute('aria-current') === 'true') return;

    this.updateOverlay(button);
    if (this.caption) {
      var caption = button.getAttribute('data-caption') || '';
      this.caption.textContent = caption;
      this.caption.hidden = caption === '';
    }

    this.buttons.forEach(function (item) {
      var selected = item === button;
      if (selected) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
      item.classList.toggle('is-active', selected);
    });

    if (this.stage) {
      this.stage.setAttribute('data-tone', button.getAttribute('data-tone') || '');
    }

    this.setPlaying(false);

    if (button.getAttribute('data-video-type') === 'youtube') {
      this.showIframe(button);
      this.setPlaying(true);
      return;
    }

    this.stopIframe();
    if (this.player) {
      this.player.hidden = false;
      this.player.removeAttribute('aria-hidden');
    }

    if (this.placeholder || !this.player) {
      this.onLoaded();
      return;
    }

    var sources = parseSources(button.getAttribute('data-sources'));
    if (!sources.length) {
      this.onError();
      return;
    }

    this.player.pause();
    this.replaceSources(sources);
    this.player.poster = button.getAttribute('data-poster') || '';
    this.player.setAttribute('aria-label', button.getAttribute('data-player-label') || button.getAttribute('data-title') || '');
    this.replaceTrack(button.getAttribute('data-subtitles') || '');
    this.player.load();
    try {
      this.player.currentTime = 0;
    } catch (error) {
      // Some browsers reset time during load(); ignore until metadata is ready.
    }

    this.onLoaded();
    this.play();
  };

  ProductVideos.prototype.replaceSources = function (sources) {
    this.player.querySelectorAll('source').forEach(function (source) {
      source.remove();
    });
    this.player.removeAttribute('src');
    sources.forEach(function (item) {
      var source = document.createElement('source');
      source.src = item.url;
      if (item.type) source.type = item.type;
      this.player.appendChild(source);
    }, this);
    this.bindSourceErrors();
  };

  ProductVideos.prototype.bindSourceErrors = function () {
    if (!this.player) return;
    this.player.querySelectorAll('source').forEach(function (source) {
      source.addEventListener('error', this.onError);
    }, this);
  };

  ProductVideos.prototype.replaceTrack = function (src) {
    this.player.querySelectorAll('track').forEach(function (track) {
      track.remove();
    });
    if (!src) return;
    var track = document.createElement('track');
    track.kind = 'captions';
    track.label = 'Captions';
    track.srclang = 'en';
    track.src = src;
    this.player.appendChild(track);
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new ProductVideos(root));
  }

  function destroyRoot(root) {
    var instance = instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-videos]').forEach(initRoot);
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll('[data-product-videos]').forEach(destroyRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    destroyAll(event.target);
    initAll(event.target);
  });
})();
